import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthMessageService {

	constructor() {
	}

	public readonly TENANT_NOT_REGISTERED: string = 'Your email is not registered! Please register and try again.';
	public readonly TENANT_REGISTERED: string = 'Your email is already registered. Please login and try again.';
	public readonly EMAIL_NOT_VERIFIED: string = 'Your email is not yet verified. Please verify and try again.';
	public readonly EMAIL_VERIFIED: string = 'Your email is already verified. Please login.';
	public readonly INVALID_PROVIDER: string = 'Your email is not registered using ';
}
